import { Component, AfterViewInit, Input, ViewChild, ViewContainerRef, NgModuleRef, ComponentFactory, NgModuleFactory, Injector, ElementRef } from "@angular/core";
import { ModuleLoaderService } from "../../services/module-loader.service";
import * as thresholdActions from '../../../threshold/store/actions/actions';
import { Store } from '@ngrx/store';

@Component({
    selector: 'celine-smart-widget',
    template: require('./smart-widget.component.html')
})

export class SmartWidgetComponent implements AfterViewInit {
    public loading = true;
    public valid = true;

    @Input() public url: string;
    @Input() public widget: string;
    @Input() public widgetData: any;
    @Input() public data: any;
    
    @ViewChild('dynamicComponentContainer', { read: ViewContainerRef }) 
    _dynamicComponentContainer: ViewContainerRef;

    constructor(private store: Store<any>, private moduleLoader: ModuleLoaderService, private injector: Injector, private elementRef: ElementRef) {}

    ngAfterViewInit() {
        
        if ((this.widgetData.type === 'smart') || (this.data)) {

            this.moduleLoader.loadModuleRef(this.url)
                .then((moduleInstance: NgModuleRef<any>) => {
                    const factories: Map<any, any> = moduleInstance.componentFactoryResolver['_factories'];
                    let matchingFactory: ComponentFactory<any> = null;
                    factories.forEach((factory: ComponentFactory<any>) => {
                        let name = factory.componentType.name;
                        if (name == this.widget) {
                            matchingFactory = factory;
                        }
                    });

                    if (matchingFactory == null) {
                        this.valid = false;
                        this.loading = false;
                        
                        window['newrelic'].addToTrace({ name: `App:<Celine> Msg:<Error occurred loading widget: ${this.widget}>`, start: new Date().getTime(), origin: '@Component: widget.component' }); // add error to session                                            
                        window['newrelic'].addPageAction('JSError', {
                        	'app': 'celine',
                        	'type': 'widget.component',
                        	'message': `Error occurred loading widget: ${this.widget}`,
                            'stack': '',
                            'ver': `${process.env.config.pkgVersion}`
                        });     
                        console.error("An error occurred loading this widget:", this.widget, '. Requested from', this.url);
                    } else {
                        this.valid = true;
                        this.loading = false;
                        this._initComponent(matchingFactory, moduleInstance.injector);   
                    }
                }).catch((error: Error) => {
                    this.valid = false;
                    this.loading = false;
                });

        } else {
            setTimeout(() => {
                this.valid = true;
                this.loading = false;
            });            
        }

        // if (this.data) {
        //     this.moduleLoader.load(this.url)
        //         .then((moduleFactory: NgModuleFactory<any>) => {
        //             const vcRef = this._dynamicComponentContainer;
        //             const ngModuleRef: NgModuleRef<any> = moduleFactory.create(this.injector);
        //             const factories: Map<any, any> = ngModuleRef.componentFactoryResolver['_factories'];
        //             let matchingFactory: ComponentFactory<any> = null;
        //             factories.forEach((factory: ComponentFactory<any>) => {
        //                 let name = factory.componentType.name;
        //                 if (name == this.widget) {
        //                     matchingFactory = factory;
        //                 }
        //             });

        //             if (matchingFactory == null) {
        //                 this.valid = false;
        //                 this.loading = false;
        //                 console.error("An error occurred loading this widget:", this.widget, '. Requested from', this.url);
        //             } else {
        //                 this.valid = true;
        //                 this.loading = false;
        //                 this._initComponent(matchingFactory,ngModuleRef.injector);   
        //             }

        //         }, (error: any) => {
        //             console.log('Error', error);
        //             this.valid = false;
        //             this.loading = false;
        //         });        
        // } else {
        //     setTimeout(() => {
        //         this.valid = true;
        //         this.loading = false;
        //     });            
        // }
    }

    private _initComponent(factory: ComponentFactory<any>,componentInjector: Injector) {
        let componentRef = this._dynamicComponentContainer.createComponent(factory,null,componentInjector);        
        componentRef.instance.data = this.data;
        componentRef.changeDetectorRef.detectChanges();
        componentRef.onDestroy(() => {
            componentRef.changeDetectorRef.detach();
        });
    }

    onClickLink(path: string) {
        this.store.dispatch(new thresholdActions.SetAllowExternalNavigationAction(true));
        setTimeout(() => {
            window.location.href = path;
        }, 1000);
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/celine/components/smart-widget/smart-widget.component.ts